import React, { useState } from "react";
import { Container, Table, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../common/Footer";
import AdminHeader from "../common/AdminHeader";
import axios from "axios";
import { baseUrl, formatDateToDDMMYYYY } from "../../Utility/constants";

const LCTrackingReport = () => {
  const [searchCriteria, setSearchCriteria] = useState("Name"); // Default selected dropdown option
  const [searchValue, setSearchValue] = useState(""); // Textbox value
  const loggedUser = localStorage.getItem("userID"); // Textbox value
  const [students, setStudents] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSearch = async () => {
    if (!searchValue) {
      setErrorMessage("Please enter a search value.");
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/api/Numbering/LCTrackingReport`,
        {
          params: {
            searchCriteria,
            searchValue,
            loggedUser,
          },
        }
      );

      setStudents(response.data); // Set students data in state
      setErrorMessage(""); // Reset any error messages
    } catch (error) {
      setErrorMessage(
        error.response?.data || "Something went wrong while fetching data."
      );
      setStudents([]); // Clear the list in case of an error
    }
  };

  return (
    <>
      <AdminHeader />
      <Container className="mt-5 mb-5">
        
        <div className="container mt-4">
          {/* Search Criteria Dropdown */}
          <div className="row">
            <div className="col-md-3">
              <select
                className="form-control"
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}>
                <option value="0">Select Search option</option>
                <option value="grno">GR No</option>
                <option value="name">Name</option>
              </select>
            </div>

            {/* Search Value Input */}
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Enter search value"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>

            {/* Search Button */}
            <div className="col-md-2">
              <button className="btn btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>

          {/* Display Error Message */}
          {errorMessage && (
            <div className="alert alert-danger mt-3">{errorMessage}</div>
          )}

          {/* Display Student List in a Table */}
          <h3>LC Tracking Report</h3>
          {students.length > 0 && (
            <div className="mt-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Student Name</th>
                    <th>General Register No</th>
                    <th>Roll No</th>
                    <th>Type</th>
                    <th>Remarks</th>
                    <th>Document</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={student.studentId}>
                      <td>{index + 1}</td>
                      <td>{student.firstName} {student.lastName}</td>
                      <td>{student.generalRegisterNo}</td>
                      <td>{student.rollNo}</td>
                      <td>{student.certType}</td>
                      <td>{student.remarks}</td>
                      <td>
                        <a
                          href={student.lcDocument}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >
                          View
                        </a>
                      </td>
                      <td>{formatDateToDDMMYYYY(student.createdOn)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
        <ToastContainer />

      </Container>
      <Footer />
    </>
  );
};

export default LCTrackingReport;
